export const checkIsValidJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

export const safeLocalStorage = {
  get: (key: string): string | null => {
    try {
      return typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  set: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined') localStorage.setItem(key, value);
    } catch (error) {
      console.warn('Failed to set item in localStorage', error);
    }
  },
  remove: (key: string): void => {
    try {
      if (typeof window !== 'undefined') localStorage.removeItem(key);
    } catch (error) {
      console.warn('Failed to remove item from localStorage', error);
    }
  }
};
